<template>
    <header class="story__head">
        <span class="subtitle--small subtitle--upper" v-if="category">
            {{ category }}
        </span>

        <h1 class="title title--dash">
            <span v-html="title"></span>
        </h1>

        <div
            class="vcard--inline"
            itemscope itemtype="https://schema.org/Person"
            v-if="author.job"
        >
            <h2 class="subtitle--header" itemprop="name" v-html="author.fullName || author.name" />
            <span class="subtitle--header" style="padding-inline: .3em"> | </span>
            <h3 class="subtitle--header" itemprop="jobTitle" v-html="author.job" />
            <div itemprop="worksFor" itemscope itemtype="https://schema.org/Organization">
                <meta itemprop="name" content="Doane Grant Thornton" />
            </div>
        </div>
    </header>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        category: {
            type: [String, Boolean],
            default: false
        },
        author: {
            type: Object,
            default: () => ({}),
        },
    },
}
</script>